// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__QGkoU","title":"styles_title___yeTQ","tagGrid":"styles_tagGrid__YQpZ1","tagCard":"styles_tagCard__VOsXJ","tagName":"styles_tagName__QKGsl"};